import { Z_INDEX } from '@/constants/styleConstants';
import { memo } from 'react';
import { Slide, toast, ToastContainer } from 'react-toastify';

/**
 * Memoized so the container only renders on its own state. react-toastify 9 registers a new toast
 * in a ref before committing it to state; a parent re-render in between (a redux update renders at
 * sync priority) mounts the toast as inactive, which starts its exit at once and drops it unseen.
 */
const SnackbarContainer = memo(function SnackbarContainer() {
  return (
    <ToastContainer
      limit={1}
      draggable={false}
      closeOnClick={false}
      position={toast.POSITION.BOTTOM_CENTER}
      autoClose={4000}
      closeButton={false}
      transition={Slide}
      style={{ zIndex: Z_INDEX.SNACKBAR }}
    />
  );
});

export default SnackbarContainer;
